import { render, staticRenderFns } from "./technical_services.vue?vue&type=template&id=6e696f8e&scoped=true"
import script from "./technical_services.vue?vue&type=script&lang=js"
export * from "./technical_services.vue?vue&type=script&lang=js"
import style0 from "./technical_services.vue?vue&type=style&index=0&id=6e696f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e696f8e",
  null
  
)

export default component.exports